import {
  ProductCartSpecificationInterface,
  ProductCartVariantInterface,
} from "@/types/cart";
import {
  ProductSpecificationInterface,
  ProductVariantInterface,
} from "@/types/product";

export const formateProductVariant = (
  variant: ProductVariantInterface[],
): ProductCartVariantInterface[] => {
  const map = new Map();

  variant.forEach((item) => {
    const mapKey = item.groupId.id;
    if (map.has(mapKey)) {
      const values = item.variantId;
      Object.assign(values, { variantId: item.id });

      const newData = map.get(mapKey);
      newData.variantId.push(values);

      map.set(mapKey, newData);
    } else {
      const newVariant = {
        ...item,
        variantId: [{ ...item.variantId, variantId: item.id }],
      };
      map.set(mapKey, newVariant);
    }
  });

  return Array.from(map.values());
};

export const formateProductSpecification = (
  properties: ProductSpecificationInterface[],
): ProductCartSpecificationInterface[] => {
  const map = new Map();

  properties.forEach((item) => {
    const mapKey = item.groupId.id;
    if (map.has(mapKey)) {
      const values = item.valueId;
      Object.assign(values, { valueId: item.id });

      const newData = map.get(mapKey);
      newData.valueId.push(values);

      map.set(mapKey, newData);
    } else {
      const newVariant = {
        ...item,
        valueId: [{ ...item.valueId, valueId: item.id }],
      };
      map.set(mapKey, newVariant);
    }
  });

  return Array.from(map.values());
};

export const isBothCartVariantSame = (
  variants: ProductCartVariantInterface[] = [],
  selected: ProductCartVariantInterface[] = [],
): boolean => {
  if (variants.length !== selected.length) {
    return false;
  }

  let i = 0;
  while (i < variants.length) {
    if (
      variants[i].variantId[0].value !== selected[i].variantId[0].value &&
      variants[i].variantId[0].variantId !== selected[i].variantId[0].variantId
    ) {
      return false;
    }

    i += 1;
  }

  return true;
};
